module.exports = __webpack_public_path__ + "static/media/bn-mockup-3.bca25ec3.png";